import type { AppSummary } from '@mod/core/model'

/** A catalog declaration, not a check for Review's name or installation id. */
export function sessionChangesContribution(apps: readonly AppSummary[]) {
  for (const app of apps) {
    const fill = (Array.isArray(app.panels) ? app.panels : []).find(
      (entry) =>
        entry.slot === 'sessionHeader' &&
        entry.kind === 'items' &&
        entry.projection === 'sessionChanges',
    )
    if (fill) {
      return {
        appId: app.id,
        dataType: app.dataType,
        title: fill.title,
        action: fill.action,
        initialRows:
          typeof fill.initialRows === 'number' &&
          Number.isInteger(fill.initialRows) &&
          fill.initialRows > 0
            ? Math.min(fill.initialRows, 20)
            : 5,
      }
    }
  }
  return null
}
